import { styled, Chip } from '@mui/material';
import moment from 'moment-timezone';

export default function PayoutChip(props) {
    const now = moment();
    const end = moment(props.payoutDate);
    const inTransit = moment.duration(now.diff(end)).asDays() <= 2;

    if (inTransit) {
        return <TransitChip label="In Transit" />;
    } else {
        return <PaidChip label="Paid" />;
    }
}

const TransitChip = styled(Chip)(({ theme }) => ({
    color: theme.palette.info.main,
    borderColor: theme.palette.info.main,
}));

TransitChip.defaultProps = { variant: 'outlined', size: 'small' };

const PaidChip = styled(Chip)(({ theme }) => ({
    color: theme.palette.success.main,
    borderColor: theme.palette.success.main,
}));

PaidChip.defaultProps = { variant: 'outlined', size: 'small' };
